import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import ProgressBar from '../ProgressBar/ProgressBar';
import PaginatedCards from '../PaginatedCards/PaginatedCards';
import './SetOverview.css';
import {HOST} from "../config";

const SetOverview = () => {
    const { id } = useParams();
    const [setData, setSetData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetch(HOST + `/api/sets/${id}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to fetch set details.');
                }
                return response.json();
            })
            .then(data => {
                setSetData(data);
                setLoading(false);
            })
            .catch(err => {
                console.error('Error fetching set:', err);
                setError('Error fetching set details.');
                setLoading(false);
            });
    }, [id]);

    if (loading) return <div>Loading set overview...</div>;
    if (error) return <div>{error}</div>;

    return (
        <div className="set-overview">
            <h1>{setData.title}</h1>
            <p className="description">{setData.description}</p>
            <p className="total-cards">Total Cards: {setData.totalCards}</p>
            {setData.progress && <ProgressBar {...setData.progress} />}
            <Link to={`/sets/${id}/study${setData.category === 'book' ? '?auto=1' : ''}`} className="study-button">
                Study This Set
            </Link>
            {/* Render the paginated cards list */}
            <PaginatedCards setId={id} />
        </div>
    );
};

export default SetOverview;
